module.exports = AMapUI;


//////////////////
// WEBPACK FOOTER
// external "AMapUI"
// module id = 2
// module chunks = 